import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyBuildingListResult,
	CompanyBuildingsState,
} from '@localTypes/companyBuildings';

const initialState: CompanyBuildingsState = {};

export const companyBuildingsSlice = createSlice({
	initialState,
	name: 'company_buildings',
	reducers: {
		clearAllCompanyBuildings: () => ({}),
		clearCompanyBuildings: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyBuildings: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyBuildingListResult['result'];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
		setCompanyBuildingsError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyBuildingsLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearAllCompanyBuildings,
	clearCompanyBuildings,
	setCompanyBuildings,
	setCompanyBuildingsError,
	setCompanyBuildingsLoading,
} = companyBuildingsSlice.actions;

export const companyBuildingsReducer = companyBuildingsSlice.reducer;
